"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderingContext = void 0;
var RenderingContext = /** @class */ (function () {
    function RenderingContext(element) {
        this._canvas = element;
    }
    RenderingContext.prototype.getCanvasWidth = function () {
        return parseFloat(this._canvas.getAttribute("width") || "0");
    };
    RenderingContext.prototype.getCanvasHeight = function () {
        return parseFloat(this._canvas.getAttribute("height") || "0");
    };
    return RenderingContext;
}());
exports.RenderingContext = RenderingContext;
//# sourceMappingURL=RenderingContext.js.map